import $ from "jquery";
import System from "../helper/system";
import store from "../storeWire";
import Product from "@system/config/product";
import ResponseMaker from "./reponseMaker/productResponseMaker";
import { set_category_filter_applied_status, set_product_facet, set_product_master_data } from "../store/slice/model/ProductListing";
import { __remove, __set } from "src/store/axios_indicator";
import { isArray } from "underscore";
import Api from "src/service/APIHandler";
import Constants from "src/helper/Constants";
const API = new Api({});
class ProductListingAPICall {

    getProductsForProductListingPageList = async ({ page = false, limit = false, extra = {} }) => {
        extra.isSkipFacets = false;
        return await this.getList(page, limit, extra, true);
    };

    getGroupList = async (search, searchFilterBasedOnManufacturer = false, ERPPartNumber = false, onlyGroup = false) => {
        __set('PRODUCT_MANUAL_SEARCH_LISTING_API_CALL');
        let isDetailSearch = false;
        let filter = '';
        if (searchFilterBasedOnManufacturer) {
            filter = "ManufacturerName eq '" + searchFilterBasedOnManufacturer + "'";
            isDetailSearch = true;
        }
        // Group call pass ERPMFRPartNumber
        if (onlyGroup && filter.trim() !== '') {
            filter += " and ERPMFRPartNumber eq '" + search + "'" + " or Ignorecase_ERPMFRPartNumber eq '" + search + "'";
        }
        let SboatF = System.avUserInfoData.speedBoatAbbr;
        if (filter) {
            filter += " and Sboat eq '" + SboatF + "'";
        } else {
            filter += "Sboat eq '" + SboatF + "'";
        }
        if (ERPPartNumber && isArray(ERPPartNumber)) {
            isDetailSearch = true;
            ERPPartNumber.map((v) => {
                filter += 'ERPPartNumber' + ' eq ' + v + ' or ' + 'Ignorecase_ERPPartNumber' + ' eq ' + v + ' or ';
            });
            filter = filter.trim().substring(0, filter.length - 4);
        }
        let res = {};

        if (search.length > 0) {
            let param = {}
            param.data = {
                filter,
                isDetailSearch,
                search: onlyGroup ? '*' : search, // Remove asterisk (*) when click on product having count > 1
            }
            await API.post(Product.PRODUCT_GROUPED_LISTING, param).then((resHer) => {
                if (resHer.data?.Data) {
                    res = resHer?.data?.Data
                }
            });
        }
        __remove('PRODUCT_MANUAL_SEARCH_LISTING_API_CALL');
        return res;
    };

    getListData = async (params) => {
        let res = {};
        let param = {}

        param.data = {
            ...params,
            isSkipFacets: true,
            isAttributesFacetInclude: false
        }

        await API.post(Product.PRODUCT_LISTING, param).then((resHer) => {
            if (resHer.data.Data) {
                res.data = resHer.data.Data;
            }
        });

        let tempRes = {
            data: {
                Count: res.data.Count,
                products: res.data.Products
            }
        }

        let res_made = new ResponseMaker(tempRes).process().run(param).get();

        res_made.config = param;
        store.dispatch(set_product_master_data(res_made));
        store.dispatch(set_product_facet({ value: res_made.value, productCount: res_made.productCount, isFrom: "PLP" }))

        __remove('PRODUCT_LISTING_API_CALL');
        return res_made
    };

    getListFacetsData = async (params) => {
        __set('PRODUCT_FACETS_API_CALL');
        let res = {};
        let param = {}

        param.data = {
            "filter": params.filter,
            "search": params.search,
            "isSkipFacets": params.isSkipFacets,
            "searchColumns": params.searchColumns,
            "facetsTypes": params.facetsTypes,
            "isAttributesFacetInclude": params.isAttributesFacetInclude
        }

        await API.post(Product.PRODUCT_LISTING_FACETS, param).then((resHer) => {
            if (resHer.data.Data) {
                res.data = resHer.data.Data;
            }
        });

        let res_made = new ResponseMaker(res).process().run(param).get();

        res_made.config = param;
        const { value, productCount, ...restObj } = res_made;

        store.dispatch(set_product_facet({ ...restObj }))
        __remove('PRODUCT_FACETS_API_CALL');
        return res_made
    };

    getList = async (page = false, limit = false, extra = {}, enable_get_url_param_edit = false) => {
        __set('PRODUCT_LISTING_API_CALL');
        let c = System.getParams()
        let reqParam = {
            search: c.search ? c.search.trim() : '',
            top: limit ? limit : 20,
            isIncludeCount: true,
            isProductImageInclude: false,
            isSkipFacets: extra?.isSkipFacets ? extra?.isSkipFacets : false,
            isPLP: true
        }

        if (c.searchColumn) {
            let res = atob(c.searchColumn)
            if (res) {
                reqParam.searchColumns = JSON.parse(res);
            }
        }

        let last_page = page - 1;
        let skip = limit * last_page;
        if (!skip || skip < 0) {
            reqParam.skip = 0;
        } else {
            reqParam.skip = skip
        }

        let p_filter = this.getFilterKeyForListing();

        if (p_filter?.categoryFilter_detected !== undefined) {
            await store.dispatch(await set_category_filter_applied_status({
                status: p_filter.categoryFilter_detected
            }));
        }

        if (p_filter?.res) {
            reqParam.filter = p_filter.res
            reqParam.isAttributesFacetInclude = p_filter?.categoryFilter_detected
        }

        if (extra?.orderby && extra?.orderbydirection) {
            reqParam.orderby = extra.orderby + " " + extra.orderbydirection + ",search.score() desc";
        }

        if (enable_get_url_param_edit) {
            c.page = page;
            c.limit = limit;
            c.orderby = extra?.orderby;
            c.orderbydirection = extra?.orderbydirection;
            history.replaceState(null, null, "?" + $.param(c));
        }
        let all_res = {}

        await Promise.all([
            this.getListData(reqParam),
            this.getListFacetsData(reqParam)
        ]).then((res) => {
            all_res = res;
        }).catch(() => {
            all_res = [{ value: [], productCount: 0 }]
        });

        __remove("UNIVERSAL_SEARCH_DEDICATED_API_BULK_CALL");

        return { ...all_res[1], value: all_res[0].value, productCount: all_res[0].productCount }
    };

    getFilterKeyForListing = () => {
        let res = '';
        let categoryFilter_detected = false;
        let appendFacadeOptions_detected = false;

        if (System.getParams().appendFacadeOptions !== undefined) {
            appendFacadeOptions_detected = System.getParams().appendFacadeOptions;
        }
        const a = Object.entries(store.getState().entities.ProductListingFilterApplied);

        if (a.length) {
            let flagFacets_filter_added = '';

            a.map((v, i) => {
                if (v[1].s !== undefined) {
                    v[1].s.map((vH, iH) => {
                        if (vH.value) {

                            const field = v[0];
                            const field_name = v[1].main_label;
                            let search_type = System.getFieldType(field);

                            if (search_type === Constants.CognitiveSearchFieldConfig.flagFacets && vH.hidden_payload !== undefined) {
                                flagFacets_filter_added = (flagFacets_filter_added.length > 0 ? flagFacets_filter_added + " and " : "") + vH.hidden_payload.key + ' eq' + " '" + vH.hidden_payload.value + "'";
                            } else if (search_type === Constants.CognitiveSearchFieldConfig.ManufacturerName || search_type === Constants.CognitiveSearchFieldConfig.normal || search_type === Constants.CognitiveSearchFieldConfig.FamilyName) {
                                const str = "(" + field + ' eq' + " '" + vH.value + "')";
                                res = res.length > 0 ? res + " and " + str : str;
                            } else if (search_type === Constants.CognitiveSearchFieldConfig.Categories) {
                                let str = "";
                                if (vH?.hidden_payload?.Level !== undefined) {
                                    const level = vH.hidden_payload.Level;
                                    str = '(Level_' + level + '_Name eq' + " '" + vH.value + "')";
                                } else {
                                    let s = '(Level_1_Name eq' + " '" + vH.value + "' or ";
                                    s += 'Level_2_Name eq' + " '" + vH.value + "' or ";
                                    s += 'Level_3_Name eq' + " '" + vH.value + "' or ";
                                    s += 'Level_4_Name eq' + " '" + vH.value + "') or ";
                                    s += ')';
                                    str = s;
                                }
                                categoryFilter_detected = true;
                                res = res.length > 0 ? res + " and " + str : str;
                            } else if (search_type === Constants.CognitiveSearchFieldConfig.attributes) {
                                const str = ` Attributes/any(attribute:attribute/ATTCOMBO eq '${field_name}|#|${vH.value}') `;
                                res = res.length > 0 ? res + " and " + str : str;
                            }
                        }
                    })
                }
            });

            if (flagFacets_filter_added) {
                flagFacets_filter_added = "(" + flagFacets_filter_added + ")";
                res = res.length > 0 ? res + " and " + flagFacets_filter_added : flagFacets_filter_added;
            }
        }

        const baseCondition = `Sboat eq '${System.avUserInfoData.speedBoatAbbr}'`;
        const SboatF = System.getParams()?.addFrom === 'BomSearchMatch' ? `${baseCondition} and distributor eq 'AVNET'` : baseCondition;
        res = res.trim();

        res = res ? `${res} and ${SboatF}` : SboatF;

        return {
            res,
            categoryFilter_detected,
            appendFacadeOptions_detected,
        };
    };

    static getFlagFacetsSearchField = (value) => {
        if (value.hidden_payload !== undefined) {
            return value.hidden_payload.key + ' eq' + " '" + value.hidden_payload.value + "' and ";
        }
        return false;
    };

    sendCurrentPageEmail = async (reqBody) => {
        __set('SEND_CONTACT_US_EMAIL_API_CALL')
        let res = {};
        let param = {}
        param.data = reqBody
        try {
            await API.post(Product.PRODUCT_LISTING_SEND_MAIL, param).then((resHer) => {
                if (resHer.data) {
                    res = resHer?.data
                }
            });
        } catch (e) {
            __remove('SEND_CONTACT_US_EMAIL_API_CALL')
        }
        __remove('SEND_CONTACT_US_EMAIL_API_CALL')
        return res;
    };

    getUniversalProductSearchList = async (searchParam = '*') => {
        let data = {
            "filter": "Sboat eq '" + System.avUserInfoData.speedBoatAbbr + "'",
            "top": 5,
            "skip": 0,
            "isIncludeCount": true,
            "isProductImageInclude": false,
            "isSkipFacets": true,
            "orderby": "search.score() desc, ERPMFRPartNumber asc",
            "search": searchParam
        };

        let res = {};
        let param = {}
        param.data = data
        try {
            await API.post(Product.UNIVERSAL_PRODUCT_SEARCH, param).then((resHer) => {
                if (resHer?.data?.Data?.Products?.length > 0) {
                    res = resHer?.data?.Data?.Products
                }
            });
        } catch (e) {
        }
        return res
    };

    getUniversalCategoryManufacturersSearchList = async (searchParam = '*') => {
        let data = {
            "filter": "Sboat eq '" + System.avUserInfoData.speedBoatAbbr + "'",
            "top": 5,
            "skip": 0,
            "isIncludeCount": false,
            "isProductImageInclude": false,
            "isSkipFacets": false,
            "orderby": "ManufacturerPartNumber asc",
            "facetsTypes": ["GlobalSearchManufacturer", "GlobalSearchCategory"],
            "search": searchParam
        };

        let res = {};
        let param = {}
        param.data = data
        try {
            await API.post(Product.UNIVERSAL_MANUFACTURERS_CATEGORY_SEARCH, param).then((resHer) => {
                if (resHer?.data?.Data) {
                    res = resHer?.data?.Data
                }
            });
        } catch (e) {
        }
        res.Categories = new ResponseMaker().processCategories(res.Categories)?.Categories;
        return res;
    };
}

export default ProductListingAPICall;